import { useQuery } from '@tanstack/react-query';
import { budgetService } from '@services/budget';

export const BUDGET_REQUESTS_BY_TASK_ID_QUERY_KEY = 'budget-requests-by-task-id';

export const useBudgetRequestsByTaskId = (taskId: string | undefined) => {
  return useQuery({
    queryKey: [BUDGET_REQUESTS_BY_TASK_ID_QUERY_KEY, taskId],
    queryFn: () => budgetService.getBudgetRequestsByTaskId(taskId!),
    enabled: !!taskId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};